import { useSiteSettings } from "@/contexts/SiteSettingsContext";
import { FacebookLogo, InstagramLogo, LinkedinLogo, YoutubeLogo, XLogo, Envelope, Phone, MapPin } from "@phosphor-icons/react";

const SOCIAL = [
  { key: "social_facebook", icon: FacebookLogo, label: "Facebook" },
  { key: "social_instagram", icon: InstagramLogo, label: "Instagram" },
  { key: "social_linkedin", icon: LinkedinLogo, label: "LinkedIn" },
  { key: "social_youtube", icon: YoutubeLogo, label: "YouTube" },
  { key: "social_x", icon: XLogo, label: "X" },
];

export function Footer() {
  const s = useSiteSettings();
  const year = new Date().getFullYear();
  const copy = (s.copyright_text || "© {YEAR} DRY ICE BULLS. ALL RIGHTS RESERVED.").replace("{YEAR}", String(year));
  return (
    <footer className="border-t border-[#262626] bg-[#0A0A0A] mt-24" data-testid="main-footer">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-8 bg-[#00D4FF] flex items-center justify-center">
              <span className="text-black font-chivo font-black">D</span>
            </div>
            <span className="font-chivo font-black text-white text-lg uppercase tracking-tight">Dry Ice Connect</span>
          </div>
          <p className="font-plex text-sm text-[#9CA3AF] max-w-xs leading-relaxed" data-testid="footer-tagline">
            {s.footer_tagline || "Private resource center for dry ice blasting contractors, equipment owners, and industrial cleaning businesses."}
          </p>
          <div className="flex items-center gap-2 mt-5" data-testid="footer-socials">
            {SOCIAL.filter((x) => s[x.key]).map((x) => (
              <a key={x.key} href={s[x.key]} target="_blank" rel="noopener noreferrer"
                 className="w-8 h-8 border border-[#262626] flex items-center justify-center text-[#9CA3AF] hover:border-[#00D4FF] hover:text-[#00D4FF]"
                 aria-label={x.label} data-testid={`footer-social-${x.key.replace('social_','')}`}>
                <x.icon size={14} weight="bold" />
              </a>
            ))}
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="font-mono text-[11px] text-[#00D4FF] tracking-widest uppercase mb-4">Platform</div>
          <ul className="space-y-2 text-sm text-[#9CA3AF]">
            <li><a href="/find" className="hover:text-white">Find a Pro</a></li>
            <li><a href="/pros" className="hover:text-white">Directory</a></li>
            <li><a href="/pricing" className="hover:text-white">Pricing</a></li>
            <li><a href="/register" className="hover:text-white">Join</a></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <div className="font-mono text-[11px] text-[#00D4FF] tracking-widest uppercase mb-4">Members</div>
          <ul className="space-y-2 text-sm text-[#9CA3AF]">
            <li><a href="/training" className="hover:text-white">Training</a></li>
            <li><a href="/downloads" className="hover:text-white">Downloads</a></li>
            <li><a href="/support" className="hover:text-white">Support</a></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono text-[11px] text-[#00D4FF] tracking-widest uppercase mb-4">Contact</div>
          <ul className="space-y-2 text-sm text-[#9CA3AF]" data-testid="footer-contact">
            {s.contact_email && (
              <li className="flex items-start gap-2"><Envelope size={14} weight="duotone" className="text-[#00D4FF] mt-0.5" /><a href={`mailto:${s.contact_email}`} className="hover:text-white" data-testid="footer-contact-email">{s.contact_email}</a></li>
            )}
            {s.contact_phone && (
              <li className="flex items-start gap-2"><Phone size={14} weight="duotone" className="text-[#00D4FF] mt-0.5" /><a href={`tel:${s.contact_phone.replace(/[^0-9+]/g,'')}`} className="hover:text-white" data-testid="footer-contact-phone">{s.contact_phone}</a></li>
            )}
            {s.contact_address && (
              <li className="flex items-start gap-2"><MapPin size={14} weight="duotone" className="text-[#00D4FF] mt-0.5" /><span data-testid="footer-contact-address">{s.contact_address}</span></li>
            )}
            <li><a href="/terms" className="hover:text-white" data-testid="footer-terms-link">Terms of Service</a></li>
            <li><a href="/privacy" className="hover:text-white" data-testid="footer-privacy-link">Privacy Policy</a></li>
            <li><a href="/refund-policy" className="hover:text-white" data-testid="footer-refund-link">Refund Policy</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#262626] py-6 px-4 lg:px-8 max-w-[1400px] mx-auto flex flex-col md:flex-row items-center justify-between gap-3 text-xs font-mono text-[#52525B]">
        <div data-testid="footer-copyright">{copy}</div>
        <div>V1.5 — STATUS: <span className="text-[#00D4FF]">OPERATIONAL</span></div>
      </div>
    </footer>
  );
}
